var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox"},[_c('input',{ref:"checkbox",staticClass:"checkbox-input",attrs:{"id":_vm.id,"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.isChecked},on:{"change":_vm.updateValue}}),_c('label',{staticClass:"checkbox-label noselect",attrs:{"for":_vm.id}},[_vm._v(" "+_vm._s(_vm.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }